module.exports = __webpack_public_path__ + "static/media/endoprothese_2.6f240e0e.jpg";